import './App.css';
import './components/views/view.css';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Start from './components/home/start';
import Splash from './components/home/splash';
import Gallery from './components/gallery/gallery';
import Photography from './components/photography/photography';
import DetailedView from './components/views/detailed';

import { useEffect, useLayoutEffect } from 'react'
import { PivotView } from './components/views/pivot';
import { TimelineView } from './components/views/timeline';
import { Collections } from './components/collections/collections';
import { Sitemap } from './components/sitemap/sitemap';
import { ServicesHome } from './components/skills/skills';
import SkillRenderer from './components/skills/layout/skillRenderer';
import Animation from './components/skills/layout/animation';
import stylizedArrow from "./assets/stylized_arrow.svg";
import { FormattedMessage } from 'react-intl';

const Wrapper = ({children}) => {
  const location = useLocation();
  const history = useNavigate();

  useEffect(() => {
    if (location.search.includes("?s=")) {
      const source = location.search.split("?s=")[1];
      history(`/gallery/view?id=${source}`, { replace: true });
    }
  });
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children
}

function App() {
  return (
    <BrowserRouter basename="/remyjeuniaux">
      <Wrapper>
        <Routes>
          <Route exact path="/" element={ <Splash/> }/>
          <Route exact path="/home" element={ <Start/> }/>
          <Route exact path="/portfolio" element={ <Start origin="portfolio"/> }/>
          <Route exact path="/gallery" element={ <Gallery/> }/>
          <Route exact path="/services" element={ <ServicesHome/> }/>
          <Route exact path="/photography" element={ <Photography/> }/>
          <Route exact path="/layout" element={ <SkillRenderer name="layout" image="layoutExample" example="oceatika"/> }/>
          <Route exact path="/animation" element={ <Animation/> }/>
          <Route exact path="/brandidentity" element={ <SkillRenderer name="brandIdentity" image="graphicDesign" example="turbulences"/> }/>
          <Route exact path="/typography" element={ <SkillRenderer name="typography" image="mockupTypoUp"/> }/>
          <Route exact path="/packaging" element={ <SkillRenderer name="packaging" image="canelleTeafront"/> }/>
          <Route exact path="/experimentations" element={ <SkillRenderer name="experimentations" image="experimentations" example="albumCovers"/> }/>
          <Route exact path="/gallery/view" element={ <DetailedView/> }/>
          <Route exact path="/collections" element={ <Collections/> }/>
          <Route exact path="/collections/view" element={ <PivotView/> }/>
          <Route exact path="/timeline" element={ <TimelineView/> }/>
          <Route exact path="/sitemap" element={ <Sitemap/> }/>
          <Route path="*" element={<div className="notFound align-center themed"><img draggable="false" style={{width: "min(35vmin, 250px)"}} alt="404" src={stylizedArrow} /><div className="align-center"><FormattedMessage id="not_found"/></div></div>} />
        </Routes>
      </Wrapper>
    </BrowserRouter>
  );
}

export default App;
